import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { AggridBanComponent } from '../../ban/aggrid-ban/aggrid-ban.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { isNullOrUndefined, isNull } from 'util';
import { DatePipe } from '@angular/common';

import { CxcmulticobdepcliService } from "../cxcservicios/cxcmulticobdepcli.service";
import { Cxcdetcobmulti } from "../cxcinterfaces/cxcdetcobmulti";
import { Cxcenccobmulti } from "../cxcinterfaces/cxcencobmulti";
import { Cxctrncobmulanc } from "../cxcinterfaces/cxctrncobmulanc";
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';

@Component({
  selector: 'app-cxcmulticobdepcli',
  templateUrl: './cxcmulticobdepcli.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxcmulticobdepcliComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonRegresar: boolean;
  botonBorrar: boolean;
  botonPrimero: boolean;
  botonAnterior: boolean;
  botonSiguiente: boolean;
  botonUltimo: boolean;
  botonAsiento: boolean;
  botonVerAsiento: boolean;

  indicador: any;

  activeIndex
  indiceTablas

  permisocobmuldepcli: SegMaePermiso
  cxcdetcobmultiSelected: Cxcdetcobmulti
  selectAll: boolean;

  //ag-grid
  rowSelection = 'multiple';
  public frameworkComponents;
  rowStyle;
  defaultColDefcxccobmulti
  defaultColDefrescxccobmulti
  defaultColDefanccxccobmulti

  defaultColumnDefCarteraFormaPago;
  defaultColumnDefCarteraVarios;
  rowStyleFp
  largo: string;
  btneditConcil = true;
  choosedColorG: string = '#EDB77F';
  choosedColorSB: string;
  choosedColor: string;
  datedesde
  datehasta

  editarCeldas: boolean;
  nuevoreg: boolean;
  // busqueda
  opcionbusqueda: string;
  types: SelectItem[];
  arregloCons: any[];
  busquedacampos: string[];
  tabla: string;
  where: string;
  spin

  //dialogs
  displayDialogBusquedaFast: boolean;
  displayDialogAsiento: boolean;

  cxcrescobmuldepcli

  cxcanccobmuldepcli: Cxctrncobmulanc[]
  cxcanccobmuldepcliapli: Cxctrncobmulanc[]

  columDefcxcobmulti = [

    {
      headerName: 'Nro. Documento', field: 'DETCOB_NRODOC', cellEditor: 'cellPrueba', width: 180, editable: (params) => {

        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 50,
          opcionbuscar: true
        }
      }
    },
    {
      headerName: 'Fecha', field: 'DETCOB_FECHA', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32
        }
      }
    },
    {
      headerName: 'Fecha Vec.', field: 'DETCOB_FECHAVENC', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: true,
          tamanocelda: 32,
        }
      }
    },
    {
      headerName: 'Concepto', field: 'DETCOB_CONCEPTO', cellEditor: 'cellPrueba', width: 200, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 200,
        }
      }
    },
    {
      headerName: 'Saldo', field: 'DETCOB_SALDOINI', cellEditor: 'agSelectCellEditor', width: 100, cellStyle: { textAlign: 'right' }, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Importe', field: 'DETCOB_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Vendedor', field: 'VEN_NOMBRE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Nombre cliente', field: 'CLI_NOMBRE', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    }
  ];
  columDefCxcrescobmulti = [
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Nombre cliente', field: 'CLI_NOMBRE', cellEditor: 'cellPrueba', width: 250, editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 5,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Total', field: 'DETCOB_IMPORTE', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 0,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
  ]
  columnDefCxccobmultianc = [
    {
      headerName: 'Nro. Anticipo', field: 'TRNCOBRO_NRODOC', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {
      headerName: 'Fecha', field: 'TRNCOBRO_FECHATRN', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {
      headerName: 'Cod. Cliente', field: 'CLI_CODIGO', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return false;
      },
    },
    {
      headerName: 'Importe', field: 'SALDO', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },

    },
    {
      headerName: 'Cruzado', field: 'TRNCOBMULANC_VALAPLI', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },

    },
    {
      headerName: 'CI.', field: 'TRNCOBMULANC_NRODOC', cellEditor: 'cellPrueba', width: 100, 
      editable: (params) => {
        return false;
      },

    },
  ]
  constructor(
    public cxcmulticobdepcliService: CxcmulticobdepcliService,
    private init: NuevoComponentService, private permisosService: PermisosService,
    private messageService: MessageService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private auditoriagral: AuditoriagralService,
    private busqService: InvbusquedaService, private utilitariosService: UtilitariosService,
  ) {
    this.agTable()
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.rowStyleFp = (params) => {

      if (params.data.APLORG_CODIGO === 'SISTEMA' &&
        params.data.TRNCOBRO_CONCEPTO.includes('CUOTA')) {
        return { background: 'rgb(255, 255, 170)' };
      }

      if (params.data.COLORDOCDEP === true) {
        return { background: 'rgb(255, 207, 185)' };
      }

      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
      if ((params.data.TRNCOBRO_FECHATRN === '' || params.data.TRNCOBRO_FECHATRN === null) &&
        (this.activeIndex === 1 || this.activeIndex === 2)) {
        return { background: '#AAFF00' };
      }
      if (params.data.COLORDOCCONC === true) {
        return { background: 'rgb(135, 234, 130)' };
      }
    };
    this.defaultColDefcxccobmulti = {
      editable: true,
      width: 130,
      objeto: 'cxcdetcobmuldepcli'
    };
    this.defaultColDefrescxccobmulti = {
      editable: true,
      width: 130,
      objeto: 'cxcrescobmuldepcli'
    }
    this.defaultColDefanccxccobmulti = {
      editable: true,
      width: 130,
      objeto: 'cxcanccobmuldepcli'
    }
  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAsiento = true;
    this.botonVerAsiento = true;

    this.activeIndex = 0;
    this.indiceTablas = 0;

    this.largo = '630';

    this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = {}
    this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = []
    this.cxcdetcobmultiSelected = {}
    this.cxcrescobmuldepcli = []
    this.cxcanccobmuldepcli = []
    this.cxcanccobmuldepcliapli = []
    await this.getPermisos();
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisocobmuldepcli = data[0];
        } else {
          this.permisocobmuldepcli = null;
        }
      } else {
        this.permisocobmuldepcli = null;
      }
    } catch (e) {
      this.permisocobmuldepcli = null;
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }
  async manejarSenales(evento) {
    if (evento !== 'Nuevo' && evento !== 'Cancelar'
      && evento !== 'Primero' && evento !== 'Anterior' && evento !== 'Siguiente' && evento !== 'Ultimo'
      && evento !== 'Buscar' && evento !== 'Imprimir' && evento !== 'AsientoVer' && evento !== 'Salir') {
      // Verifica el periodo contable
      const dia = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.getDate();
      const mes = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.getMonth();
      const anio = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.getFullYear();

      //ANTES ESTABA COMENTADO
      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }

    if (evento === 'Nuevo') {
      if (this.permisocobmuldepcli.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisocobmuldepcli.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'cobmuldepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Guardar') {
      if (this.permisocobmuldepcli.PERTODO === 1) {
        this.spin = true;
        this.guardar()
      } else {
        if (this.permisocobmuldepcli.PERACTUALIZACION === 1) {
          this.spin = true;
          this.guardar()
        } else {
          this.messageService.add({
            key: 'cobmuldepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Buscar') {
      if (this.permisocobmuldepcli.PERTODO === 1) {
        this.buscarregistro();
      } else {
        if (this.permisocobmuldepcli.PERSELECCION === 1) {
          this.buscarregistro();
        } else {
          this.messageService.add({
            key: 'cobmuldepcli',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de búsqueda, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Borrar') {
      if (this.permisocobmuldepcli.PERTODO === 1) {
        this.confirmarborrar();
      } else {
        if (this.permisocobmuldepcli.PERELIMACION === 1) {
          this.confirmarborrar();
        } else {
          this.messageService.add({
            key: 'cobmul',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Cancelar') {
      this.cancelar();
    }
    if (evento === 'Primero') {
      this.seleccionarRegistro('P')
    }
    if (evento === 'Anterior') {
      this.seleccionarRegistro('A')
    }
    if (evento === 'Siguiente') {
      this.seleccionarRegistro('S')
    }
    if (evento === 'Ultimo') {
      this.seleccionarRegistro('U')
    }
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  async seleccionarRegistro(tipo) {
    try {
      let cod = isNullOrUndefined(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO) ? '' : this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
      const rs = await this.cxcmulticobdepcliService.getregistro(tipo, cod)
      if (rs !== null && rs.length > 0) {
        await this.encontrarregistro(rs[0].ENCCOB_CODIGO)
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al seleccionar el registro ' + error.error
      });
    }
  }
  async confirmarborrar() {
    try {
      let encond = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO;
      let comprobante = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE
      const data = await this.cxcmulticobdepcliService.gettrncobmultipro(encond)
      if (data.length > 0 && data !== null) {
        for (const iterator of data) {
          if (iterator.NUMERO > 0) {
            this.messageService.add({
              key: 'cobmuldepcli',
              severity: 'error',
              summary: 'Información',
              detail: 'Reverse primero los pagos generados, para poder eliminar el registro completo '
            });
            return;
          }
        }
      }
      if (isNullOrUndefined(encond) || encond === '') {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un registro'
        });
        return
      }
      this.confirmationService.confirm({
        message: 'Esta seguro que desea eliminar el registro',
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        key: 'cobmuldepcliConf',
        acceptLabel: 'Si',
        rejectLabel: 'No',
        accept: async () => {
          this.confirmationService.close();
          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO = ''
          await this.cxcmulticobdepcliService.eliminarencocbmulti(encond)
          this.auditoriagral.registrarAuditoria('CXC_ENCCOBRO_MULTIPLE',
            encond + '/' + comprobante + '', 'E',
            '', '01', '', '', '', '').subscribe();

          await this.cancelar();
          this.messageService.add({
            key: 'cobmuldepcli',
            severity: 'success',
            summary: 'Información',
            detail: 'Éxito al eliminar '
          });
        },
        reject: () => {
          this.confirmationService.close();
        }
      });
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al intentar eliminar el documentos ' + error
      });
      console.log(error)
      return
    }

  }
  buscarregistro() {

    this.opcionbusqueda = 'BUSCARREGISTRO';
    this.types = [
      { label: 'Código', value: 'ENCCOB_CODIGO' },
      { label: 'Comprobante', value: 'ENCCOB_COMPROBANTE' },
      { label: 'Fecha Emisión', value: 'ENCCOB_FECHAEMISION' },
      { label: 'Importe', value: 'ENCCOB_IMPORTE' },
      { label: 'Concepto', value: 'ENCCOB_CONCEPTO' }
    ];
    this.busquedacampos = ['', '', '', '', ''];
    this.tabla = 'CXC_ENCCOBRO_MULTIPLE';
    this.where = 'ENCCOB_ORIGEN =\'CXCDEP\'';

    this.busqService.busquedacxcencocbmultianc().subscribe((datos: any[]) => {
      if (datos !== null) {
        datos.map(x => {
          x.ENCCOB_IMPORTE = Number(x.ENCCOB_IMPORTE).toFixed(2)
          x.ENCCOB_FECHAEMISION = this.datePipe.transform(x.ENCCOB_FECHAEMISION, 'dd/MM/yyyy')
        })
        this.arregloCons = datos;
        this.spin = false;
        this.displayDialogBusquedaFast = true;
      }
    });
  }
  async guardar() {
    try {
      let docselected = this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].filter(x =>
        this.utilitariosService.mayor(x.DETCOB_IMPORTE, 0) === true)
      let ancselected = this.cxcanccobmuldepcli.filter(x =>
        this.utilitariosService.mayor(x.TRNCOBMULANC_VALAPLI, 0) === true)
        const vendedor = [
          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_CODIGO
        ]
      const data=await this.cxcmulticobdepcliService.validavendedores(vendedor);
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE === '' || isNullOrUndefined(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE)) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar el número del comprobante'
        });
        this.spin = false;
        return
      }
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_CODIGO === '' || isNullOrUndefined(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_CODIGO)) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un vendedor'
        });
        this.spin = false;
        return
      }
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CONCEPTO === '' || isNullOrUndefined(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CONCEPTO)) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar el concepto del cobro'
        });
        this.spin = false;
        return
      }
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION === '' || isNullOrUndefined(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION)) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe ingresar la fecha del cobro'
        });
        this.spin = false;
        return
      }
      if (this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle de los documentos no puedes estar vacío'
        });
        this.spin = false;
        return
      }
      if (Object.entries(docselected).length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'No hay documentos cruzados'
        });
        this.spin = false;
        return
      }
      if (Object.entries(ancselected).length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Información',
          detail: 'No hay anticipos cruzados'
        });
        this.spin = false;
        return
      }
      if (data !== null && data !== undefined ) {
        if (data.length > 0) {
          this.messageService.add({
            key: 'cobmuldepcli',
            severity: 'error',
            summary: 'Error',
            detail: 'Hubo un error al validar el vendedor, por favor revisar ' 
          });
          this.spin = false;
        return
        }
      }
      await this.finguardar()
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al validar los documentos ' + error.error
      });
      this.spin = false;
      console.log(error)
    }

  }
  async finguardar() {
    try {
      let enccod = ''
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.toString().includes('-')) {
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION = this.datePipe.transform(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION, 'dd/MM/yyyy')
      }
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE = Number(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE)
      const rs = await this.cxcmulticobdepcliService.insertaenccobmulti(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador])
      if (rs !== null) {
        for (const item of rs) {
          enccod = item[':B2']
          await this.auditoriagral.registrarAuditoria('CXC_ENCCOBRO_MULTIPLE',
            enccod + '/Comprobante:' + this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE + '', 'I',
            '', '01', '', '', '', '').toPromise();

          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO = enccod

          const datedet = this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].filter(x =>
            this.utilitariosService.mayor(x.DETCOB_IMPORTE, 0) === true)


          const areglodet = datedet.map(({ DETCOB_NRODOC,
            DETCOB_IMPORTE, DETCOB_REF, CLI_CODIGO
          }) => ({
            p_enccob_codigo: enccod,
            p_com_codigo: '01',
            p_detcob_nrodoc: DETCOB_NRODOC,
            p_detcob_importe: DETCOB_IMPORTE,
            p_detcob_nrocomprobante: '',
            p_detcob_ref: DETCOB_REF,
            p_cli_codigo: CLI_CODIGO,
            p_trncobro_nrodoc: '',
            p_contro_grabar: ''
            // p_USU_identificacion_4: this.cxcmulticobdepcliService.usuario.identificacion,
            // p_AUD_equipo: this.utilitariosService.getHostname(),
            // p_AUD_ippublica: this.utilitariosService.getIpFrontend()
          }))
          const areglodetanc = this.cxcanccobmuldepcliapli.map(({ CLI_CODIGO, TRNCOBRO_NRODOC, NUMDOC, TRNCOBMULANC_VALFAC,
            TRNCOBMULANC_VALANC, TRNCOBMULANC_VALAPLI
          }) => ({
            p_ENCCOB_CODIGO: enccod,
            p_COM_CODIGO: '01',
            p_CLI_CODIGO: CLI_CODIGO,
            p_TRNCOBRO_NRODOC: TRNCOBRO_NRODOC,
            p_NUMDOC: NUMDOC,
            p_TRNCOBMULANC_VALFAC: TRNCOBMULANC_VALFAC,
            p_TRNCOBMULANC_VALANC: TRNCOBMULANC_VALANC,
            p_TRNCOBMULANC_VALAPLI: TRNCOBMULANC_VALAPLI,
            p_TRNCOBMULANC_ESTADO: 'P'
            // p_USU_identificacion_4: this.cxcmulticobdepcliService.usuario.identificacion,
            // p_AUD_equipo: this.utilitariosService.getHostname(),
            // p_AUD_ippublica: this.utilitariosService.getIpFrontend()
          }))


          await this.cxcmulticobdepcliService.insertadetcobmulti(areglodet);
          await this.cxcmulticobdepcliService.insertatrnanccobmulti(areglodetanc);
          await this.auditoriagral.registrarAuditoria('CXC_DETCOBRO_MULTIPLE',
            enccod + '/Comprobante:' + this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE + '', 'I',
            '', '01', '', '', '', '').toPromise();
          await this.auditoriagral.registrarAuditoria('CXC_TRNCOBMULANC',
            enccod + '/Comprobante:' + this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE + '', 'I',
            '', '01', '', '', '', '').toPromise();
        }
      }
      await this.cancelar();
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'success',
        summary: 'Información',
        detail: 'Documento guardado exitosamente '
      });
      this.spin = false;
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar los documentos ' + error.error
      });
      this.spin = false;
      console.log(error)
    }
  }
  cambiarFoco(event) {
    let element: any;
    switch (event.target.id) {
      case 'ENCCOB_COMPROBANTE': {
        element = document.getElementById('VEN_CODIGO');
        break;
      }
      case 'ENCCOB_FECHAEMISION': {
        //this.busquedacliente(event.target.value);
        element = document.getElementById('VEN_CODIGO');
        break;
      } case 'VEN_CODIGO': {
        //this.busquedacliente(event.target.value);
        //element = document.getElementById('CEN_CODIGO');
        this.busquedavendedor(event.target.value)
        break;
      } case 'DESDE': {
        //this.busquedacliente(event.target.value);
        //element = document.getElementById('CEN_CODIGO');
        element = document.getElementById('HASTA');
        break;
      }
      default: {
        break;
      }
    }
    //console.log(element)
    if (element === null || element === undefined) {
      return;
    } else {
      element.focus();
    }
  }
  nuevo() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.botonPrimero = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonUltimo = true;
    this.botonAsiento = true;
    this.botonVerAsiento = true;

    this.selectAll = false;
    this.datedesde = new Date()
    this.datehasta = new Date()
    this.indiceTablas = 0;
    this.nuevoreg = true;
    this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = {}
    this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = []
    this.cxcmulticobdepcliService.cxctrnformapagoarray[this.indicador] = [];
    this.cxcmulticobdepcliService.cxctrnvariosarray[this.indicador] = [];
    this.cxcrescobmuldepcli = []
    this.cxcanccobmuldepcli = []
    this.cxcanccobmuldepcliapli = []
    this.cxcdetcobmultiSelected = {}


    const dato: Cxcenccobmulti = {
      ASI_NRO: '',
      COM_CODIGO: '01',
      ENCCOB_CODIGO: '',
      ENCCOB_COMPROBANTE: '',
      ENCCOB_CONCEPTO: '',
      ENCCOB_FECHAEMISION: new Date(),
      ENCCOB_IMPORTE: Number(0).toFixed(2),
      ENCCOB_IMPRESO: '',
      TOTALDEUDA: Number(0).toFixed(2),
      TOTALVAR: Number(0).toFixed(2),

      VEN_CODIGO: '',
      VEN_NOMBRE: '',
      ENCCOB_ORIGEN: 'CXCDEP'
    }
    this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = dato
    document.getElementById('contorno').style.pointerEvents = 'all';
    this.aggrid.habilitarGrid();
    setTimeout(() => {
      document.getElementById('ENCCOB_COMPROBANTE').focus();
    }, 100);

  }
  async cancelar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
    this.botonAsiento = true;
    this.botonVerAsiento = true;
    this.activeIndex = 0;
    this.indiceTablas = 0;
    this.datedesde = '';
    this.datehasta = '';
    this.selectAll = false;
    this.cxcrescobmuldepcli = []
    this.cxcanccobmuldepcli = []
    this.cxcanccobmuldepcliapli = []

    let codigo = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO;
    if (isNullOrUndefined(codigo) || codigo === '') {
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = {}
      this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = []
      this.cxcmulticobdepcliService.cxctrnformapagoarray[this.indicador] = [];
      this.cxcmulticobdepcliService.cxctrnvariosarray[this.indicador] = [];
      this.cxcdetcobmultiSelected = {}



      document.getElementById('contorno').style.pointerEvents = 'none';
      this.aggrid.bloquearGrid();
    } else {
      await this.encontrarregistro(codigo)
      document.getElementById('contorno').style.pointerEvents = 'none';
      this.aggrid.bloquearGrid();
    }
  }
  async encontrarregistro(codigo) {
    this.datedesde = new Date()
    this.datehasta = new Date()
    try {
      this.spin = true
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = false;
      this.botonRegresar = true;
      this.botonPrimero = false;
      this.botonAnterior = false;
      this.botonSiguiente = false;
      this.botonUltimo = false;
      this.botonAsiento = true;
      this.botonVerAsiento = true;
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = {}
      this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = []
      this.cxcmulticobdepcliService.cxctrnformapagoarray[this.indicador] = [];
      this.cxcmulticobdepcliService.cxctrnvariosarray[this.indicador] = [];
      this.cxcdetcobmultiSelected = {}
      this.cxcrescobmuldepcli = []
      this.cxcanccobmuldepcli = []
      this.cxcanccobmuldepcliapli = []
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR=0
      const rs = await this.cxcmulticobdepcliService.getenccxccobmulti(codigo)
      if (rs !== null && rs.length > 0) {
        for (const iterator of rs) {
          iterator.ENCCOB_FECHAEMISION = new Date(iterator.ENCCOB_FECHAEMISION)
          iterator.ENCCOB_IMPORTE = this.utilitariosService.formatear(iterator.ENCCOB_IMPORTE, 2)
          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador] = iterator;
          const data1 = await this.cxcmulticobdepcliService.getdetcxccobmulti(codigo)
          const data2 = await this.cxcmulticobdepcliService.getTrncobmulanc(codigo)

          if (data1 !== null && data1.length > 0) {
            for (const item1 of data1) {
              item1.DETCOB_IMPORTE = this.utilitariosService.formatear(item1.DETCOB_IMPORTE, 2)
              item1.DETCOB_SALDOINI=Number(0).toFixed(2)
              item1.SELECCIONADO = true;
            }
            this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = data1;
          }
          if (data2 !== null && data2.length > 0) {
            for (const item1 of data2) {
              item1.TRNCOBMULANC_VALFAC = this.utilitariosService.formatear(item1.TRNCOBMULANC_VALFAC, 2)
              item1.TRNCOBMULANC_VALANC = this.utilitariosService.formatear(item1.TRNCOBMULANC_VALANC, 2)
              item1.TRNCOBMULANC_VALAPLI = this.utilitariosService.formatear(item1.TRNCOBMULANC_VALAPLI, 2)
              item1.TRNCOBMULANC_NRODOC= isNullOrUndefined(item1.TRNCOBMULANC_NRODOC)?'':item1.TRNCOBMULANC_NRODOC;
            }
            this.cxcanccobmuldepcli = data2
            this.cxcanccobmuldepcliapli = data2
          }
          for (const iterator of this.cxcanccobmuldepcli) {
            this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR=
            this.utilitariosService.sumar(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR,iterator.TRNCOBMULANC_VALAPLI)
          }
          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR=this.utilitariosService.formatear(
            this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR,2
          )
          this.spin = false
          document.getElementById('contorno').style.pointerEvents = 'none';
        }
      } else {
        this.spin = false
      }

    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información ' + error.error
      });
      this.spin = false;
      console.log(error)
    }

  }
  seleccionDocumento(params) {
    if (params.object !== undefined) {
      this.cxcdetcobmultiSelected = params.object;

    }
  }
  async seleccionAncDepcli(params) {
    let codigo = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO

    if (params === 'cargaranc') {
      // if (isNullOrUndefined(codigo) === false && codigo !== '') {
      //   this.messageService.add({
      //     key: 'cobmuldepcli',
      //     severity: 'error',
      //     summary: 'Error',
      //     detail: 'No se pueden cargar anticipos, debe eliminar el documento y volverlo a ingresar'
      //   });
      //   return
      // }
      if (this.cxcanccobmuldepcli.length>0) {
                this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Ya hay anticipos cargados, no se pueden cargar más'
        });
        return
      } 
      if (this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'No hay información en la pestaña de documentos'
        });
        return;
      }
      this.getancdepmulcli()
      return
    }
    if (params === 'cruzaranc') {
      if (isNullOrUndefined(codigo) === false && codigo !== '') {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'No se pueden cruzar anticipos, debe eliminar el documento y volverlo a ingresar'
        });
        return
      }
      if (this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'No hay información en la pestaña de documentos'
        });
        return;
      }
      if (this.cxcanccobmuldepcliapli.length>0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Los anticipos ya han sido cruzados'
        });
        return;
      }
      const data = this.cruzarvalores(this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador], this.cxcanccobmuldepcli);
      this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = []
      this.cxcanccobmuldepcli = []
      this.cxcanccobmuldepcliapli = []
      this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = data.facturas
      this.cxcanccobmuldepcli = data.anticipos
      this.cxcanccobmuldepcliapli = data.aplicaciones
      for (const iterator of this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador]) {
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE=
        this.utilitariosService.sumar(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE,iterator.DETCOB_IMPORTE)
      }
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE=this.utilitariosService.formatear(
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE,2
      )

      for (const iterator of this.cxcanccobmuldepcli) {
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR=
        this.utilitariosService.sumar(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_IMPORTE,iterator.TRNCOBMULANC_VALAPLI)
      }
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR=this.utilitariosService.formatear(
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].TOTALVAR,2
      )
      this.aggrid.refreshaggrid(this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto);
    }
    if (params === 'generarab') {
      const detpagado = this.cxcanccobmuldepcliapli.filter(x => x.TRNCOBMULANC_ESTADO === 'P')
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento'
        });
        return
      }
      if (detpagado.length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Los pagos ya han sido generados'
        });
        return
      }
      this.generarabonos()
      return
    }
    if (params === 'reversarab') {
      const detpagado = this.cxcanccobmuldepcliapli.filter(x => x.TRNCOBMULANC_ESTADO === 'G')
      if (this.botonGuardar === false) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Guarde primero el documento'
        });
        return
      }
      if (detpagado.length === 0) {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'Los pagos no han sido generados'
        });
        return
      }
      this.reversarabonos()
      return
    }
  }
  async generarabonos() {
    try {
      let fecha = ''
      if (this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION.toString().includes('-')) {
        fecha = this.datePipe.transform(this.datedesde, 'dd/MM/yyyy')
      } else {
        fecha = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_FECHAEMISION
      }
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'success',
        summary: 'Información',
        detail: 'Proceso para la generación de pagos iniciado exitosamente, le notificaremos via correo'
      });
      await this.cxcmulticobdepcliService.generarabonos(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador], fecha);
      await this.cancelar()
      await this.auditoriagral.registrarAuditoria('CXC_TRNCOBMULANC',
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
        + '/Comprobante:' + this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE + '/GENERAR-PAGOS' + '', 'I',
        '', '01', '', '', '', '').toPromise();
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al generar los pagos'
      });
      console.log(error)
      return
    }
  }
  async reversarabonos() {
    try {

      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'success',
        summary: 'Información',
        detail: 'Proceso para reversar los pagos ha iniciado exitosamente, le notificaremos via correo'
      });
      await this.cxcmulticobdepcliService.reversarabonos(this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador]);
      await this.auditoriagral.registrarAuditoria('CXC_TRNCOBMULANC',
        this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
        + '/Comprobante:' + this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_COMPROBANTE + '/REVERSAR-PAGOS' + '', 'E',
        '', '01', '', '', '', '').toPromise();
      await this.cancelar()

    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Error',
        detail: 'Hubo un error al reversar los pagos'
      });
      console.log(error)
      return
    }
  }
  cruzarvalores(documentos, anticipos) {
    const aplicaciones = []
    this.spin = true;
    try {
      //Copias para no modificar los arreglos originales
      const facturas = documentos.map(f => ({
        ...f,
        saldoPendiente: f.DETCOB_SALDOINI
      }));
      const listaAnticipos = anticipos.map(a => ({
        ...a,
        saldoDisponible: a.SALDO
      }))

      // Agrupar facturas por cliente

      const mapFacturas = new Map()

      facturas.forEach(f => {
        if (!mapFacturas.has(f.CLI_CODIGO)) {
          mapFacturas.set(f.CLI_CODIGO, [])
        }
        mapFacturas.get(f.CLI_CODIGO).push(f)
      });

      // Agrupar anticipos por cliente

      const mapAnticipos = new Map()

      listaAnticipos.forEach(a => {
        if (!mapAnticipos.has(a.CLI_CODIGO)) {
          mapAnticipos.set(a.CLI_CODIGO, [])
        }
        mapAnticipos.get(a.CLI_CODIGO).push(a)
      });

      // Cruce
      mapAnticipos.forEach((anticiposCliente, cliente) => {
        const facturasCliente = mapFacturas.get(cliente);
        if (!facturasCliente) {
          return
        }
        let indiceFactura = 0
        let importe = 0;

        for (const anticipo of anticiposCliente) {
          while (
            this.utilitariosService.mayor(anticipo.saldoDisponible, 0) &&
            indiceFactura < facturasCliente.length
          ) {
            const factura = facturasCliente[indiceFactura]
            if (this.utilitariosService.igual(factura.saldoPendiente, 0)) {
              indiceFactura++;
              importe = 0
              continue;
            }
            const valorAplicado = this.utilitariosService.min(
              anticipo.saldoDisponible,
              factura.saldoPendiente
            )
            aplicaciones.push(
              {
                CLI_CODIGO: cliente,
                TRNCOBRO_NRODOC: anticipo.TRNCOBRO_NRODOC,
                NUMDOC: factura.DETCOB_NRODOC,
                TRNCOBMULANC_VALFAC: factura.DETCOB_SALDOINI,
                TRNCOBMULANC_VALANC: anticipo.SALDO,
                TRNCOBMULANC_VALAPLI: valorAplicado
              }
            )


            factura.saldoPendiente = this.utilitariosService.restar(
              factura.saldoPendiente, valorAplicado
            )
            factura.DETCOB_IMPORTE = this.utilitariosService.formatear(this.utilitariosService.sumar(factura.DETCOB_IMPORTE, valorAplicado), 2)

            anticipo.saldoDisponible = this.utilitariosService.restar(
              anticipo.saldoDisponible,
              valorAplicado
            )
            anticipo.TRNCOBMULANC_VALAPLI = this.utilitariosService.formatear(this.utilitariosService.sumar(anticipo.TRNCOBMULANC_VALAPLI, valorAplicado), 2)

            if (this.utilitariosService.igual(factura.saldoPendiente, 0)) {
              indiceFactura++;
            }

          }

        }

      });
      console.log(aplicaciones)
      console.log(facturas)
      console.log(listaAnticipos)
      this.spin = false;
      return {
        facturas,
        anticipos: listaAnticipos,
        aplicaciones
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cruzar los valores ' + error.error
      });
      this.spin = false;
      console.log(error)
    }


  }
  async getancdepmulcli() {
    try {
      this.spin = true;
      const data = await this.cxcmulticobdepcliService.getancdepmulticli();
      if (data.length > 0 && isNullOrUndefined(data) === false) {
        for (const iterator of data) {
          iterator.SALDO = this.utilitariosService.formatear(iterator.SALDO, 2)
          iterator.TRNCOBRO_FECHATRN = this.datePipe.transform(iterator.TRNCOBRO_FECHATRN, 'dd/MM/yyyy');
          iterator.TRNCOBMULANC_VALAPLI = Number(0).toFixed(2)
        }
        this.cxcanccobmuldepcli = data
        this.cxcanccobmuldepcliapli = []
        for (let index = 0; index < this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length; index++) {
          const element = this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador][index];
          element.DETCOB_IMPORTE = Number(0).toFixed(2)
        }
        this.spin = false;
        this.aggrid.refreshaggrid(this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto);
      } else {
        this.spin = false;
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar los anticipos ' + error.error
      });
      this.spin = false;
      console.log(error)
    }
  }
  actualizarTablas() {
    if (this.indiceTablas === 1) {
      let codigo = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
      if (isNullOrUndefined(codigo) === false && codigo !== '') {
        this.cxcrescobmuldepcli = []
        if (this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length > 0) {
          const resumen = Object.values(
            this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].reduce((acc, item) => {
              const key = `${item.CLI_CODIGO}-${item.CLI_NOMBRE}`
              if (!acc[key]) {
                acc[key] = {
                  CLI_CODIGO: item.CLI_CODIGO,
                  CLI_NOMBRE: item.CLI_NOMBRE,
                  DETCOB_IMPORTE: 0
                }
              }
              acc[key].DETCOB_IMPORTE = this.utilitariosService.formatear(this.utilitariosService.sumar(acc[key].DETCOB_IMPORTE, item.DETCOB_IMPORTE), 2)
              return acc
            }, {})
          )
          this.cxcrescobmuldepcli = resumen
        }
      } else {
        this.cxcrescobmuldepcli = []
        if (this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].length > 0) {
          const resumen = Object.values(
            this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador].reduce((acc, item) => {
              const key = `${item.CLI_CODIGO}-${item.CLI_NOMBRE}`
              if (!acc[key]) {
                acc[key] = {
                  CLI_CODIGO: item.CLI_CODIGO,
                  CLI_NOMBRE: item.CLI_NOMBRE,
                  DETCOB_IMPORTE: 0
                }
              }
              acc[key].DETCOB_IMPORTE = this.utilitariosService.formatear(this.utilitariosService.sumar(acc[key].DETCOB_IMPORTE, item.DETCOB_SALDOINI), 2)
              return acc
            }, {})
          )
          this.cxcrescobmuldepcli = resumen
        }
      }


    }

  }
  seleccionarTodos() {

  }
  async consultardocs() {
    try {
      let codigo = this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].ENCCOB_CODIGO
      if (isNullOrUndefined(codigo) === false && codigo !== '') {
        this.messageService.add({
          key: 'cobmuldepcli',
          severity: 'error',
          summary: 'Error',
          detail: 'No se pueden cargar documentos, debe eliminar el documento y volverlo a ingresar'
        });
        return
      }
      let desde = ''
      let hasta = ''
      this.spin = true;
      if (this.datedesde.toString().includes('-')) {
        desde = this.datePipe.transform(this.datedesde, 'dd/MM/yyyy')
      } else {
        desde = this.datedesde
      }
      if (this.datehasta.toString().includes('-')) {
        hasta = this.datePipe.transform(this.datehasta, 'dd/MM/yyyy')
      } else {
        hasta = this.datehasta
      }
      const rs = await this.cxcmulticobdepcliService.desplegarDocumentos(desde, hasta)
      if (rs !== null) {
        let cxcdetdocs: Cxcdetcobmulti[] = []
        let cxcdetdocumento: Cxcdetcobmulti = {}
        let strTipoDoc = '';
        this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = [];
        this.cxcrescobmuldepcli = []
        this.cxcanccobmuldepcli = []
        for (const iterator of rs) {
          cxcdetdocumento = {}
          cxcdetdocumento.SELECCIONADO = false;
          cxcdetdocumento.DETCOB_NRODOC = iterator.DOCUMENTO;
          cxcdetdocumento.DETCOB_FECHA = this.datePipe.transform(iterator.FECHA, 'dd/MM/yyyy');
          cxcdetdocumento.DETCOB_CONCEPTO = iterator.CONCEPTO;
          cxcdetdocumento.DETCOB_SALDOINI = this.utilitariosService.formatear(iterator.SALDO, 2)//Number(iterator.SALDO).toFixed(2);
          cxcdetdocumento.VEN_NOMBRE = iterator.VENDEDOR;
          cxcdetdocumento.APLORG_CODIGO = iterator.APLORG_CODIGO;
          cxcdetdocumento.DETCOB_IMPORTE = Number(0).toFixed(2)
          cxcdetdocumento.CLI_NOMBRE = iterator.CLI_NOMBRE;
          cxcdetdocumento.CONTRO_GRABAR = ''

          if (iterator.TRNCOBRO_TIPODOC === 'FC') {
            strTipoDoc = "F";
          } else {
            strTipoDoc = iterator.TRNCOBRO_TIPODOC;
          }
          cxcdetdocumento.DETCOB_REF = (strTipoDoc);
          cxcdetdocumento.CLI_CODIGO = iterator.CLI_CODIGO;
          cxcdetdocumento.DETCOB_FECHAVENC = this.datePipe.transform(iterator.FECHAVENCE, 'dd/MM/yyyy');
          cxcdetdocs.push(cxcdetdocumento)
        }
        this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador] = cxcdetdocs
        this.aggrid.refreshaggrid(this.cxcmulticobdepcliService.cxcdetcobmulti[this.indicador], this.defaultColDefcxccobmulti.objeto);
        this.cxcmulticobdepcliService.calcularTotalDeuda();
        this.spin = false;
      } else {
        this.spin = false;
      }
    } catch (error) {
      this.messageService.add({
        key: 'cobmuldepcli',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar los documentos ' + error.error
      });
      this.spin = false;
      console.log(error)
    }
  }
  changeTabs() {

  }
  busquedavendedor(parametro) {
    if (parametro === null) {
      parametro = '';
    }
    this.opcionbusqueda = 'vendedor';
    this.types = [
      { label: 'Código', value: 'VEN_CODIGO' },
      { label: 'Nombre', value: 'VEN_NOMBRE' }
    ];
    this.busquedacampos = [parametro, ''];
    this.tabla = 'VEN_MAEVENDEDOR';
    this.where = '';

    this.cxcmulticobdepcliService.erBusquedaVendedor('*', this.tabla, this.types[0].value, parametro).subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_NOMBRE = eR[0].VEN_NOMBRE;
          document.getElementById('ENCCOB_CONCEPTO').focus();
        } else {
          this.spin = true;
          this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
            this.arregloCons = datos;
            this.spin = false;
            this.displayDialogBusquedaFast = true;
          });
        }
      } else {
        this.spin = true;
        this.busqService.busquedaVenMaeVendedor3(parametro).subscribe((datos: any[]) => {
          this.arregloCons = datos;
          this.spin = false;
          this.displayDialogBusquedaFast = true;
        });
      }
    });
  }
  cambio(evento) {

  }
  manejarSeleccion(opcion) {
    if (this.opcionbusqueda === 'vendedor') {
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_CODIGO = opcion.VEN_CODIGO
      this.cxcmulticobdepcliService.cxcenccobmulti[this.indicador].VEN_NOMBRE = opcion.VEN_NOMBRE
      //this.strCodigoContable = isNullOrUndefined(opcion.CON_CODIGO) ? '' : opcion.CON_CODIGO
      this.displayDialogBusquedaFast = false
      document.getElementById('ENCCOB_CONCEPTO').focus()
    }
    if (this.opcionbusqueda === 'BUSCARREGISTRO') {
      this.encontrarregistro(opcion.ENCCOB_CODIGO)
    }
    this.displayDialogBusquedaFast = false
  }

}
